import { useState } from "react";

const FORM_URL = "https://lovelinez.github.io/api/form/da2luc2amq5jpe1hs09g";

export default function ContactSection() {
  const [formError, setFormError] = useState("");
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // honeypot check
    const hp = String(data.get("company_alt") || "").trim();
    if (hp) {
      setSuccess(true);
      form.reset();
      return;
    }
    // remove empty honeypot
    data.delete("company_alt");

    setSubmitting(true);
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        body: new URLSearchParams(data as unknown as Record<string, string>),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (res.ok && code === "OK") {
        setSuccess(true);
        form.reset();
      } else {
        const msg =
          serverMsg ||
          (parsed && parsed.code ? parsed.code : "") ||
          "提交失败，请稍后再试。";
        setFormError(String(msg));
      }
    } catch (err) {
      setFormError("网络异常，提交失败，请稍后再试。");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section id="contact" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <span className="text-sm font-semibold text-primary-600">联系我们</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
              想补充内容或聊聊你的 CP？
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论是发现人物介绍有遗漏、想分享你的感情线解读，还是对角色与 CP 有不同看法，都欢迎留言。我们会认真阅读每一条反馈，并持续完善这部作品的内容整理。
            </p>
            <div className="mt-8 space-y-4">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-600">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">联系邮箱</p>
                  <p className="text-sm font-medium text-foreground-800">lovehelper@example.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-lg text-accent-600">
                  <i className="ri-chat-3-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">互动平台</p>
                  <p className="text-sm font-medium text-foreground-800">微博 · 小红书 · 粉丝社群</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="text-lg font-bold text-foreground-900">给我们留言</h3>
            {success && (
              <div className="mt-4 flex items-center gap-2 rounded-md bg-secondary-100 px-4 py-3 text-sm text-secondary-900">
                <i className="ri-checkbox-circle-line"></i> 感谢你的留言，我们会尽快与你联系！
              </div>
            )}
            {formError && (
              <div className="mt-4 flex items-start gap-2 rounded-md bg-primary-100 px-4 py-3 text-sm text-primary-800">
                <i className="ri-error-warning-line mt-0.5"></i> {formError}
              </div>
            )}
            <form data-readdy-form onSubmit={handleSubmit} className="mt-5 space-y-4">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-foreground-700">
                  你的昵称
                </label>
                <input
                  type="text"
                  name="nickname"
                  required
                  placeholder="怎么称呼你"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
              </div>
              <div>
                <label className="mb-1.5 block text-sm font-medium text-foreground-700">
                  联系邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="you@example.com"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
              </div>
              <div>
                <label className="mb-1.5 block text-sm font-medium text-foreground-700">
                  留言内容
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="写下你想说的内容（最多500字）"
                  className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
              </div>
              {/* honeypot */}
              <div className="form-hp" aria-hidden="true">
                <label>company</label>
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                className="w-full whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {submitting ? "提交中…" : "发送留言"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}